var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconShield = function SvgIconShield(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333q-2.895-.73-4.78-3.323-1.887-2.594-1.887-5.76V4.167L10 1.667l6.667 2.5V9.25q0 3.166-1.885 5.76-1.886 2.595-4.782 3.323m0-1.75q2.166-.687 3.583-2.75A7.9 7.9 0 0 0 15 9.25V5.313l-5-1.875-5 1.874V9.25q0 2.52 1.417 4.583 1.416 2.063 3.583 2.75"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconShield);
export { ForwardRef as ReactComponent };